// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"2c308d74","550":"178500fa","574":"2c308d74"}[chunkId] + ".chunk.css";
};